import {Component} from "@angular/core";

@Component({
  selector: 'app-help',
  templateUrl: './help.html'
})

export class Help {
  title: string;
}
